export default __webpack_public_path__ + "static/media/KycBackground.94a8998b.jpg";